export const getDashboardRedirectUrl = (
  baseUrl: string,
  tempCode: string,
  redirectPath: string,
): string =>
  `${baseUrl}/auth/exchange?uwSsoTmpAuthCode=${tempCode}&redirect=${encodeURIComponent(redirectPath)}`;
